import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { AuthService } from '../../../services/auth.service';

@Component({
	selector: 'app-video',
	templateUrl: './video.component.html',
	styleUrls: ['./video.component.scss']
})
export class VideoComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('videoForm', { static: true }) videoForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	videoFormSubscription: Subscription;
	isAdmin;
	isYouTubeVideo = false;

	constructor(private comService: ComponentService, private auth: AuthService) {}

	ngOnInit() {
		this.isAdmin = this.auth.isAdmin();

		this.isYouTubeVideo = this.componentData.config.videoSource.includes('www.youtube.com');

		this.videoFormSubscription = this.videoForm.valueChanges
			.pipe(
				tap(() =>
					this.comService.updateDisabledSave((this.videoForm.dirty && this.videoForm.invalid) || this.nameField.editComponentName)
				),
				filter((form) => this.videoForm.dirty && this.videoForm.valid),
				tap(() => this.comService.updateComponentData(this.componentData)),
				debounceTime(1000)
			)
			.subscribe();
	}

	ngOnDestroy() {
		this.videoFormSubscription.unsubscribe();
	}

	brodcastToPreview() {
		this.comService.updateComponentData(this.componentData);
		this.comService.updatePreviewData();
	}

	checkYouTube(event) {
		this.isYouTubeVideo = event && event.youtube;
		if (this.componentData.config.youtube_gmail && !this.isYouTubeVideo) {
			this.componentData.config.youtube_gmail = false;
		}
	}
}
